// 設定値はすべてここに置く(数値の正)。仕様書(docs/ゲーム仕様書.md)には項目名で書く。
// sim(試合の計算)が読む値を変えたら sim.version を上げる(古いリプレイが再現できなくなるため)。

export const config = {
  sim: {
    version: 16, // 2026-11-03 母艦の体力(hpSize 1.6→1)
    tickRate: 60, // 1秒あたりのステップ数(固定)
    runSeconds: 180, // 前進する長さ(秒)。止まっている間(holds)は数えない。ここまで進めばクリア(2026-11-01 オーナー要望「一試合が長い。5分→3分に圧縮」で 300 から。3面以降の秒はすべて 0.6 倍)
  },

  // 自動スクロールの空間(レール空間)。自機は z=0 の面の中を動き、敵は前(z−)と横から来る
  field: {
    // 広さ・速さは倍率1のときの値。ステージが進むと倍率(config.scale)で広がる。sim では fieldOf(world)(src/sim/scale.js)で読む
    halfWidth: 60, // 自機が動ける範囲(x)
    halfHeight: 34, // 自機が動ける範囲(y)
    spawnFrontZ: -400, // 2026-10-29 -520から近づけた(倒している様子が見えるように) // 前から来る敵の出現位置
    spawnSideX: 120, // 横から来る敵の出現位置(左右)
    despawnBehindZ: 60, // これより後ろへ抜けた物は消す
    scrollSpeed: 90, // 見た目の前進速度(m/秒。背景の流れと、拾い物が流れてくる速さ)
  },

  player: {
    radius: 4,
    speed: 55, // m/秒
    maxShield: 100,
    hitInvulnSeconds: 0.8,
    regenPerSecond: 0, // SHIELDの自然回復(2026-10-29 オーナーの感想「いつ回復したか分からない」で0に。回復は修理カプセルと強化だけ) // 被弾したあと無敵の時間
    magnetRadius: 18, // 経験値を吸い寄せる距離
  },

  enemies: {
    maxAlive: { pc: 300, mobile: 150 }, // 画面に出す敵の最大数(2026-10-29 オーナー決定)
    types: {
      pod: { hp: 10, speed: 40, radius: 5, damage: 8, xp: 1, score: 10 },
      dasher: { hp: 6, speed: 85, radius: 4.5, damage: 12, xp: 2, score: 20 },
      gunner: { hp: 26, speed: 26, radius: 5.5, damage: 10, xp: 4, score: 40, holdZ: -220, fireSeconds: 2.4, shotSpeed: 70 },
      // 大物(big)だけの値。sizeMul: 出たときの倍率に、さらに掛ける大きさ(見た目・当たり判定・砲口の位置)。hpSize: 体力の計算に使う大きさ(無ければ sizeMul)。
      // cannon: チャージ主砲(enemies.cannon に重ねる)。2026-11-01 オーナー要望「スマホだと遠くて小さい。小母艦は3倍、母艦はさらに大きく」で sizeMul を足した(体力は前のまま)
      boss: { hp: 4200, speed: 14, radius: 40, damage: 30, xp: 60, score: 5000, holdZ: -620, fireSeconds: 0.5, shotSpeed: 60, shots: 7, muzzleZ: 116, big: true, label: "MOTHERSHIP", sizeMul: 4, hpSize: 1, cannon: { damage: 35, halfWidth: 10 } }, // hpSize: 2026-11-03 1.6→1(昔の見た目だけの大きさ scale.bossSize 1.6 が体力に入り、約1.4倍固かった。オーナー「2面の母艦が異常に硬い」)。muzzleZ: 弾の出る所(中心から前へ。見た目の主砲の砲口の先)。holdZ: 大きくした分だけ下げた(砲口から自機までの距離は前とほぼ同じ)
      // 色の玉の敵(2026-10-31 オーナー決定。出る順は enemies.roster)。緑玉=pod・赤玉=dasher・青玉=gunner・紫玉=splitter(と割れた shard)・黄玉=mine
      splitter: { hp: 16, speed: 34, radius: 6, damage: 10, xp: 2, score: 30 }, // 分裂型: 倒すと shard 2機に分かれる
      shard: { hp: 4, speed: 62, radius: 3, damage: 6, xp: 1, score: 5 },
      mine: { hp: 14, speed: 30, radius: 4, damage: 14, xp: 3, score: 30, armRange: 26, fuse: 0.9, blast: 16, blastDamage: 40 }, // 機雷
      // 中ボス(2026-10-31 オーナー決定。停止戦の主役。holds の leader)。big: 体力のバーを出し、倒すと必ず修理カプセルと経験値をばらまく
      miniboss: { hp: 650, speed: 16, radius: 18, damage: 25, xp: 30, score: 1500, holdZ: -330, fireSeconds: 1.1, shotSpeed: 55, shots: 5, muzzleZ: 52, big: true, label: "SMALL MOTHERSHIP", sizeMul: 3, hpSize: 1, cannon: { damage: 22, halfWidth: 8, every: 10 } }, // 小母艦: 母艦(半径40m)を0.45倍にした形(を sizeMul 倍)
      bigpod: { hp: 15000, speed: 14, radius: 30, damage: 30, xp: 60, score: 4000, holdZ: -480, sizeMul: 4, hpSize: 1, fireSeconds: 0.7, shotSpeed: 60, shots: 9, muzzleZ: 30, big: true, label: "LARGE POD", weakLatitude: 0.5, weakDamage: 3, escorts: 6, escortRing: 1.5, escortSpinSeconds: 24, cannon: { damage: 30, halfWidth: 9 } }, // 大玉(SENSEOFVOID の中ボスの大型ポッド)。弾が当たった所の高さが中心から半径の weakLatitude 倍より上下なら、weakDamage 倍(上下の帯が弱点)。2026-11-01 オーナー要望「大玉はラスボスらしくさらに大きく硬く」で hp 3000→15000・sizeMul 4(体力は sizeMul では増やさない)・holdZ −380→−480
      // 大玉の護衛のドローンポッド(2026-11-01 オーナー要望「大玉の周りにダークシルバーの大き目のドローンポッドを6機つけてボス感を強化。ドローンポッドもプレイヤーを狙って撃ってくる。SENSEOFVOIDも同じ仕様」)。
      // 大玉(bigpod の escorts 機)と一緒に出て、大玉のまわりの輪(大玉の半径 × escortRing。自機の方を向いた面)を escortSpinSeconds で1周しながら、自機を狙って1発ずつ撃つ。復活しない。大玉が落ちると一緒に爆発する
      escort: { hp: 160, speed: 0, radius: 9, damage: 20, xp: 6, score: 300, fireSeconds: 2.6, shotSpeed: 65, muzzleZ: 9, sizeMul: 3, hpSize: 1 },
      // ステージの仕掛け(敵として扱う物。gimmicks を参照)
      satellite: { hp: 40, speed: 0, radius: 7, damage: 0, xp: 0, score: 100, gems: 8 }, // 補給衛星: ぶつからない。壊すと経験値と修理カプセル
      rock: { hp: 30, speed: 0, radius: 7, damage: 14, xp: 1, score: 10 }, // 流れてくる岩
    },
    // チャージ主砲(2026-11-01 オーナー要望「母艦も時々主砲を撃つ。わかりやすくチャージしてから。じっとしていると食らうが、見ていれば避けられる」。大玉も同じ)。
    // 大物が持ち場に着いてから first 秒後、その後 every 秒ごと。charge 秒ためる(その間は自機を狙い続け、最後の lock 秒は狙いを固める)→ fire 秒、まっすぐ太い光を撃つ。
    // 当たり: 光が自機の面(z=0)を通る所から、半径 halfWidth(×出たときの倍率)+ 自機の半径の内側。チャージ中と撃っている間は、いつもの弾を撃たず、横にも揺れない
    cannon: { first: 6, every: 9, charge: 2.4, lock: 0.8, fire: 0.6, halfWidth: 9, damage: 30 },
    shotRadius: 1.6,
    shotDamage: 6,
    hpGrowthPerMinute: 0.35, // 1分ごとに敵の体力を何割増やすか
    // 出現の強さ(時間(秒) → 毎秒の出現数)。間は直線でつなぐ
    // 2026-10-29 オーナーの感想「序盤から敵が多く、減らせている感覚が薄い」で序盤を減らした
    spawnCurve: [
      [0, 0.7],
      [18, 1.6],
      [54, 4.2],
      [90, 8.4],
      [126, 13],
      [180, 20],
    ],
    sideRatio: 0.3, // 横から来る敵の割合
    // 敵の出る順(2026-10-31 オーナー決定「緑玉→赤玉→小母艦→青玉→紫玉→黄玉→母艦→大玉」)。
    // いつもの出現は from(前進の秒)を過ぎた種類から、ratio の割合で選ぶ(上から順に足していき、残りは緑玉)。小母艦・大玉は holds の leader、母艦は bossAt。
    // 初めて出るときのミラの一言と説明は src/i18n/ の enemy.<type>.mila・enemy.<type>.hint(src/main.js)
    roster: [
      { type: "dasher", from: 18, ratio: 0.22 },
      { type: "gunner", from: 45, ratio: 0.12 },
      { type: "splitter", from: 60, ratio: 0.15 },
      { type: "mine", from: 90, ratio: 0.08 },
    ],
    bossAt: 126, // 母艦(ボス)が出る秒
  },

  // 停止戦(2026-10-29 オーナー案「節目で停止して、その場の敵を殲滅→また前進」)。
  // 前進が at 秒に来たら止まり、wave の敵が囲んでくる。全部倒すと「ALL CLEAR」で前進を再開する。
  // 母艦戦も停止戦(enemies.bossAt で止まり、母艦を倒すと再開)。maxSeconds を過ぎたら、残りがいても前進を再開する
  holds: {
    list: [
      // id: 文のキーの名前(始まったときのミラの一言と説明は src/i18n/ の hold.<id>.mila・hold.<id>.hint。hint は無くてもよい)。
      // leader: その停止戦の主役(中ボス)
      { id: "miniboss", at: 31, leader: "miniboss", wave: { pod: 15, dasher: 5 } },
      { id: "wave2", at: 67, wave: { pod: 22, dasher: 9, gunner: 3, splitter: 3 } },
      { id: "wave3", at: 103, wave: { pod: 27, dasher: 12, gunner: 5, splitter: 5 } },
      { id: "bigpod", at: 153, leader: "bigpod", wave: { pod: 30, dasher: 15, gunner: 5, splitter: 5, mine: 5 } },
    ],
    maxSeconds: 35, // 2026-11-01 試合の圧縮で 45 から。波の数も 0.75 倍にした
    easeSeconds: 1.5, // 止まる・動き出すまでの時間
    clearBonus: { repair: 1, gems: 12 }, // 全滅させたときのごほうび(修理カプセルと経験値)
  },

  // 修理カプセル(拾うとSHIELDが回復する。緑の箱)
  repair: {
    amount: 18, // 2026-10-31 オーナー要望「やや簡単になりすぎた。回復量を30%ほど減らす」で 25 から減らした
    dropChance: { pod: 0.012, dasher: 0.02, gunner: 0.12, splitter: 0.02, mine: 0.03, satellite: 1 }, // 倒したときに落とす割合(母艦・中ボスは必ず落とす)
    radius: 2.5,
    reachYRatio: 3, // 拾える範囲の上下(Y)を、左右・前後の何倍にするか(2026-10-31 オーナー要望「上下のずれで回復が取りづらい」)
  },

  xp: {
    gemRadius: 1.5,
    drift: 0.8, // 流れてくる経験値が、上下左右に自機へ寄る強さ(毎秒の割合)
    // レベルnに上がるのに必要な経験値 = base + step × (n−2)
    base: 3,
    step: 2.5, // 2026-11-01 試合を 3 分に圧縮したとき、同じくらいのレベルに届くように 4 から下げた
  },

  slow: {
    scale: 0.3, // SLOW中の時間の進み
    bossKillSeconds: 2.0,
    levelUpSeconds: 0.5,
  },

  rewind: {
    stock: 3, // 1回のプレイで使えるR.W.N.D.の回数
    keyframeSeconds: 5, // リプレイ・R.W.N.D.用の控えの間隔
    backSecondsOnDeath: 3, // 撃墜後に開いたとき、最初に選ばれている位置(何秒前)
    // 救済: 同じ展開でまたやられないように、R.W.N.D.で戻った直後は少し無敵。
    // さらに DOPA を払うと、修理(SHIELD 満タン)・出力ブースト(しばらく攻撃力アップ)をつけて再開できる
    invulnSeconds: 2.5,
    boosts: {
      heal: { cost: 50 }, // 名前・説明は src/i18n/ の boost.<id>.name・boost.<id>.desc
      power: { cost: 80, seconds: 20, damage: 1.6 },
    },
  },

  levelUp: {
    choices: 3,
  },

  // 武器の進化(src/sim/upgrades.js の WEAPONS.<武器>.evolution)。武器がLv5のとき、対になる強化がこのレベル以上なら進化が選べる
  evolution: {
    needPassiveLevel: 3,
  },

  // スケール感(2026-10-30 オーナー案。src/sim/scale.js)。ステージが進むほど、自機以外の世界が大きくなり、カメラが引いて広角になる。
  // 倍率はステージごとの scale(config.stages)。自機の大きさと、サーベル・主砲・ミサイルの爆発・吸い寄せの範囲には掛けない
  scale: {
    easeSeconds: 6, // ステージが変わってから、次の倍率になるまでの秒
    playerSpeedFollow: 0.6, // 自機の速さに倍率をどれだけ掛けるか(0=そのまま〜1=倍率どおり)。広くなった範囲を動き回れるように
    hpPerSize: 0.5, // 大きい敵の体力の増え方(体力 × (1 + (大きさ−1) × これ))
    // 見た目だけ
    fovPerScale: 8, // 倍率が1増えるごとに、視野角を何度広げるか
    maxFov: 95,
    markFollow: 0.5, // 自機の足元の輪・敵の弾の見た目を、倍率の何乗で大きくするか(小さくなりすぎて読めなくならないように)
  },

  // 面(2026-10-31 オーナー決定「クリアごとに選べるカードが増える。1面=小母艦まで3分・2面=母艦まで4分・3面=大玉まで5分(今の構成)・4〜6面は3面の構成で敵が少しずつ強い」)。
  // 面ごとの違いは src/sim/missions.js が下の stages・enemies.roster・holds・bossAt に重ねて作る。番号は world.params.mission(試合の前に決まる)。
  //   length: クリアになる前進の秒(minutes: カードに出す目安の分。停止戦の分を含む)。roster: { 種類: 出始める秒 }(書かない種類は出ない。null なら enemies.roster のまま)。
  //   holds: 停止戦({ base: holds.list の番号, at, final, ...上書き }。final: 時間切れなし=倒すまで続く)。null なら holds.list のまま。
  //   boss: 母艦の出る秒(null で出ない)。bossFinal: 母艦戦を時間切れなしにする。areas: { エリア: 始まる秒 }(書かないエリアは通らない)。
  //   spawnCurve: いつもの出現(null なら enemies.spawnCurve)。enemy: 敵の体力・攻撃・出現数の倍率と、growth: 時間で体力が増える速さ(enemies.hpGrowthPerMinute)の倍率。dopa: もらえる DOPA の倍率。
  //   clear: クリアしたときのミラの絵(一言は src/i18n/ の mission.<面>.clear。link: SENSEOFVOID へのボタンを出す。thanks: Thank you for playing!)
  missions: [
    {
      name: "FIRST CONTACT",
      length: 100,
      minutes: 2,
      roster: { dasher: 17 },
      holds: [{ base: 0, at: 93, final: true, wave: { pod: 15, dasher: 6 }, id: "finalMiniboss" }],
      boss: null,
      areas: { orbit: 0, asteroid: 47 },
      spawnCurve: [
        [0, 0.7],
        [20, 1.6],
        [60, 3.4],
        [93, 4.3],
      ],
      enemy: { hp: 1, damage: 1, spawn: 1, growth: 1.5 },
      dopa: 1,
      clear: { img: "mila-stage1" },
    },
    {
      name: "MOTHERSHIP",
      length: 140,
      minutes: 3,
      roster: { dasher: 12, gunner: 44, splitter: 60, mine: 88 },
      holds: [
        { base: 0, at: 32 },
        { base: 1, at: 76 },
      ],
      boss: 136,
      bossFinal: true,
      areas: { orbit: 0, asteroid: 32, colony: 68, moon: 100 },
      spawnCurve: [
        [0, 0.7],
        [20, 1.6],
        [60, 4.2],
        [100, 8.4],
        [136, 12],
      ],
      enemy: { hp: 1, damage: 1, spawn: 1, growth: 1.25 },
      dopa: 1.3,
      clear: { img: "mila-stage2" },
    },
    { name: "LARGE POD", enemy: { hp: 1, damage: 1, spawn: 1, growth: 1.67 }, dopa: 1.6, clear: { img: "mila-stage3", link: true } },
    { name: "HARD", enemy: { hp: 1.35, growth: 3.4, damage: 1.3, spawn: 1.15 }, dopa: 2, clear: { img: "mila-stage4", link: true } },
    { name: "EXPERT", enemy: { hp: 1.8, growth: 5.6, damage: 1.6, spawn: 1.26 }, dopa: 2.5, clear: { img: "mila-stage5", link: true } },
    { name: "ACE", enemy: { hp: 2.05, growth: 7.5, damage: 1.8, spawn: 1.35 }, dopa: 3, clear: { img: "mila-stage6", link: true, thanks: true } },
  ],

  // 面ごとの目標(src/meta/goals.js の STAGE_GOALS)の DOPA。面の dopa 倍率がかかる。初めて達成したときだけ
  stageGoals: { clear: 50, norewind: 100, allholds: 100 },

  // ステージ(2026-10-29 オーナー決定: 1回の中で移り変わる)。scale: スケール感の倍率(config.scale)。from: 始まる秒。見た目・ミラの一言・遊び方の説明(src/i18n/ の stage.<id>.mila・stage.<id>.hint。短く)と、そのステージの仕掛けが変わる。name は画面に出す英語の名前(両方の言語で同じ)
  // gimmick: そのステージの仕掛け(gimmicks)。2026-10-30 段階1「ステージごとに敵1種と仕掛け1つ」のうち、敵は 2026-10-31 に enemies.roster(時間で決まる出る順)へ移した
  stages: [
    { id: "orbit", scale: 1, from: 0, name: "EARTH ORBIT", gimmick: "satellite" },
    { id: "asteroid", scale: 1.35, from: 36, name: "ASTEROID BELT", gimmick: "rock" },
    { id: "colony", scale: 1.7, from: 72, name: "ABANDONED COLONY", gimmick: "fence" },
    { id: "moon", scale: 2.1, from: 108, name: "LUNAR SURFACE", gimmick: "flak" },
    { id: "atmosphere", scale: 2.6, from: 144, name: "ATMOSPHERIC ENTRY", gimmick: "heat" },
  ],
  // ステージの仕掛け(src/sim/stage-rules.js)。every: 出す間隔(秒)
  gimmicks: {
    satellite: { every: 14 },
    rock: { every: 1.6 },
    fence: { every: 6, speed: 150, halfWidth: 2.5, damage: 12 }, // 前から流れてくる赤いレーザーの棒。自機の面を通るとき、棒の上にいると当たる
    flak: { every: 5, warnSeconds: 1.3, fireSeconds: 0.4, halfWidth: 5, damage: 10 }, // 予告の線のあと、地上から縦の光の柱
    heat: { edge: 0.7, damagePerSecond: 5 }, // 動ける範囲の外側 3割にいると SHIELD が減る
  },
  stageFadeSeconds: 4,

  // オペレーター(ミラ)の一言(src/main.js の say。2026-10-31 オーナー要望「早くて読めない」で、短文・画面の上・前の一言を最低限見せてから替える)
  operator: {
    seconds: 3.5, // 1つの一言を出しておく秒
    minSeconds: 2.2, // 次の一言が来ても、今の一言をこの秒は見せる
    queueMax: 2, // 待たせておける一言の数
  }, // 前のステージから次へ移り変わる時間

  // 初めての出撃の前のミラの説明(index.html の #tutorial、文は src/i18n/ の tutorial.*)に設定値は無い。見たかは src/meta/device.js が覚える。

  // 手ごたえの演出(見た目と、画面の止まり方だけ。試合の結果は変わらない。2026-10-30 段階1「気持ちいい」)
  juice: {
    hitStopHurt: 0.08, // 被弾したとき、試合を止める秒(ヒットストップ)
    hitStopKill: 0.035, // 射撃型など大きめの敵を倒したとき
    hitStopGap: 0.4, // 倒したときのヒットストップは、この秒より詰めて起こさない(続くとカクつくため)
    damageSeconds: 0.7, // ダメージの数字が見えている秒
    damageMergeSeconds: 0.15, // 同じ敵への当たりを1つの数字にまとめる秒
    damageMax: 60, // 同時に出す数字の最大数
    damageFromZ: -300, // これより遠い敵の数字は出さない
    hurtSeconds: 0.6, // 被弾の向きを見せる秒
    comboSeconds: 2.0, // この秒のうちに次を倒すとコンボが続く(試合の中の時間)
    comboMin: 5, // この数からコンボを表示する
    // 面のクリアの後の大爆発(src/view/finale.js。秒は実時間)。2026-11-05 オーナー要望「ボスを撃墜した瞬間に消えてしまうのを、大爆発まで見せてから」
    finale: {
      seconds: 3.8, // 最後の大物を倒してクリアしたとき、クリアの画面を出すまで
      secondsNoBoss: 1.4, // 大物を倒さずにクリアしたとき(時間で)
      bossRecentSeconds: 2, // クリアのこの秒(試合の中の時間)以内に倒した大物を「最後の大物」とみなす
      smallFrom: 0.1, // 残っている小さな敵が爆発していく秒(この間にばらばらに)
      smallTo: 0.9,
      maxSmall: 40, // 爆発させる小さな敵の最大数(多すぎると粒と音が重い。残りはそのまま映る)
      chain: 6, // 大物のまわりの連鎖爆発の数
      chainFrom: 0.25, // 連鎖爆発の始まりの秒
      chainSize: 0.5, // 連鎖爆発の大きさ(大物の大きさに掛ける)
      megaAt: 1.5, // 真ん中の一番大きな爆発の秒
      megaSize: 1.6,
    },
  },

  // 見た目だけの値(試合の結果は変わらない)
  graphics: {
    maxPixelRatio: 2,
    autoScales: [1, 0.85, 0.7, 0.55],
    autoDownFps: 50,
    autoDownAfterSeconds: 3,
    autoUpFps: 57,
    autoUpAfterSeconds: 10,
    autoMinIntervalSeconds: 3,
    levels: {
      low: { pixelScale: 0.55, particleScale: 0.35, bloom: false, stars: 250, props: 0.5 },
      mid: { pixelScale: 0.8, particleScale: 0.65, bloom: true, stars: 400, props: 0.75 },
      high: { pixelScale: 1, particleScale: 1, bloom: true, stars: 600, props: 1 }, // stars: 2026-10-29「宇宙塵が多すぎる」で2500から減らした
    },
    maxParticles: 6000,
    // 色の決まり(2026-10-30 段階1「読める」)。自分の攻撃=寒色・細長い、敵の弾=赤・丸+輪、経験値=金、回復=緑の十字
    colors: {
      spread: 0x3fd8ff,
      missile: 0xa77bff,
      missileTrail: 0xc9b0ff,
      saber: 0x8a7dff,
      enemyShot: 0xff2a2a,
      enemyShotRing: 0xff5a7a,
      xp: 0xffd23a,
      xpGlow: 0xff9a00,
      repair: 0x4dff7a,
      repairGlow: 0x1fcc55,
    },
    // 着弾予告(src/view/depth.js。2026-10-30 段階1「読める」)。
    // 2026-10-30 オーナー要望「方眼の地面と影は説明的すぎて没入感が減る」で、床の格子・影・自機の足元の輪はやめた
    depth: {
      floorGap: 12, // 自機が動ける範囲の下端から、地上(対空砲の柱の根元)までの距離
      warnSeconds: 1.0, // 着弾予告を出し始める、自機の面に届くまでの秒
      warnRadius: 16, // 自機からこの距離の中を通る弾だけ予告する
    },
    thrusterInnerColors: { white: "#bcd8ff", red: "#ffd9b0" },
    // 敵のポッドの「危なさ」(src/view/pods.js の addDangerLook。2026-11-01 オーナー要望。見た目だけ)
    podDanger: {
      rimColor: "#ff3a12", // 輪郭の熱の光の色
      rimStrength: 1.6, // 輪郭の光の強さ
      rimPower: 2.2, // 大きいほど光が縁に寄って細くなる
      rimPulseHz: 1.3, // 脈打つ速さ(1秒に何回)
      sparkColor: "#ffc070", // 放電の筋の色
      sparkStrength: 4.0, // 放電の筋の明るさ
      sparkRate: 9, // 放電の形が変わる回数(1秒に)
      sparkChance: 0.35, // そのうち光る回の割合
    },
    // まぶしさ(2026-10-30 オーナーの感想「後半やや光が強すぎてまぶしい」)。倍率(スケール感)が大きいほど弱める: 強さ × 倍率^(−fade)
    glare: {
      bloom: 0.55, // 光のにじみの強さ(倍率1のとき)
      bloomFade: 0.6, // 倍率2.6で約0.31
      particleFade: 0.35, // 爆発などの粒の明るさ。倍率2.6で約0.72倍
    },
    shieldLowRatio: 0.3, // SHIELD がこの割合より少ないと、バーを赤く点滅させる(src/main.js)
    shieldBarBelow: 7, // SHIELD のバーを、自機の中心からどれだけ下(m)にぶら下げるか(src/view/overlay.js)
    // 母艦の形の見え方(SENSEOFVOID の config.effects.mothershipLook と mothershipTurret からコピー。src/view/mothership-geometry.js)
    bossLook: {
      chamferRatio: 0.12, // 胴体の6本の稜線を削る幅(その位置の胴体の半径に対する割合)
      edgeBevelM: 3, // 前後の端面の縁を斜めに削る量(m)
      ribZs: [-35, 35], // 胴体を一周する補強の帯の位置(中心からの前後の位置m。艦首=マイナス)
      hullMetalness: 0.1,
      hullRoughness: 0.55,
      partsColor: "#c4c8d0", // 部品(主砲の砲口・噴射口・帯・対空砲)の色
      partsMetalness: 0.3,
      partsRoughness: 0.5,
      glowColor: "#ff8a5c", // 主砲の砲口の奥・噴射口の奥の光(赤軍の色)
      turrets: { perSide: 3, spacingZ: 60 }, // 対空砲の並び(片側の門数・前後の間隔m)
    },
    skins: {
      player: "assets/textures/textures_plan1.jpg",
      enemy: "assets/textures/general-pod-white.jpg", // 2026-10-31 色の玉の敵のため白に(色は src/view/stage-objects.js の POD_LOOKS で掛ける)
      largePod: "assets/textures/large-pod.jpg",
    },
    // 視点(src/view/camera-modes.js。2026-10-30 オーナー要望で3つに)。order の順に切り替える。最初は order[0](背後)
    // back: 自機からの後ろへの距離、up: 高さ、lookY・lookZ: 見る先(自機からの高さ・前への距離)、follow: 自機の上下左右の動きにどれだけ付いていくか(0〜1)
    // 距離は倍率1のときの値(主観以外はスケール感の倍率を掛ける)
    cameraUnlockRuns: 1, // 結果まで遊んだ回数(save.records.runs)がこれ以上なら視点を切り替えられる(1回目は背後に固定。2026-10-31 オーナー要望「二回目以降に視点変更」)
    // 視点の名前は src/i18n/ の camera.<id>
    cameras: {
      order: ["chase", "high", "cockpit"],
      chase: { back: 58, up: 22, lookY: -4, lookZ: -120, follow: 0.75 }, // 2026-10-30 オーナー要望で少し上げて、気持ち見下ろす(前は up 13・lookY 0)
      high: { back: 46, up: 64, lookY: -10, lookZ: -90, follow: 0.7 },
      cockpit: { back: -3, up: 2, lookZ: -300, fovAdd: 6 }, // 自機の位置から前を見る
    },
    // 試合の後のリプレイだけの演出カメラ(src/view/replay-camera.js。2026-10-31 オーナー要望「SENSEOFVOID のように俯瞰でかっこよく」)。
    // R.W.N.D.の位置選びでは使わない(状況が読みやすい、遊んだときの視点のまま)。
    // 見えてはいけない所(敵が出る・消える所、月面の地面の端、廃コロニーの円筒の外)が見えないよう、自機の近くに留めて後ろは向かない。
    // side: 横へのずれ(AUTO では左右を交互に)、sway: 1カットの間に横へ流れる量。ほかの意味は cameras と同じ(倍率1のときの値)
    replayCameras: {
      order: ["auto", "chase", "top", "side", "wide", "high", "cockpit"], // リプレイ画面のボタン・V キーで切り替える順
      auto: { name: "AUTO" }, // 出来事に合わせて下の shots を切り替える
      top: { name: "俯瞰", back: 20, up: 130, lookY: -10, lookZ: -45, follow: 0.6, sway: 30 },
      side: { name: "真横", side: 140, back: -10, up: 25, lookY: 0, lookZ: -220, follow: 0.6, sway: 25 },
      wide: { name: "引き", back: 150, up: 70, lookY: -10, lookZ: -220, follow: 0.4, sway: 40 },
      director: {
        shots: ["chase", "top", "side", "wide", "high"], // AUTO で使う視点(主観は酔いやすいので入れない)
        shotSeconds: 6, // 1カットの長さ(試合の秒)
        // 出来事が起きたら、その視点にしばらく切り替える(秒)
        onEvent: { boss: { shot: "wide", seconds: 5 }, holdStart: { shot: "wide", seconds: 4 }, bigKill: { shot: "top", seconds: 3 } },
      },
      // 見えてはいけない所を隠すための制限(倍率に関係なく、この値)
      maxRadius: 280, // 進む向きの軸からの距離の上限(廃コロニーの円筒は半径320。外へ出ると壁が消える)
      maxBack: 300, // 自機より後ろへ下がれる距離の上限(月面の地面・コロニーは自機の400m後ろで終わる)
      minY: -110, // 下へ行ける限り(月面の地面は y=-140)
      growSeconds: 0.6, // 敵が出てきたとき、この秒で大きさ0から育つ(ポンと出るのを隠す)
      shrinkBehind: 0.5, // 敵が後ろで消える前に、消える位置までの残りのこの割合で縮む
    },
  },

  sound: {
    masterVolume: 0.6,
    bgmVolume: 0.35,
    minIntervalMs: 45, // 同じ音を続けて鳴らす最短の間隔
    // 音ごとの間引き(上の minIntervalMs の代わりに使う)。maxVoices = 同時に重ねて鳴らす数の上限
    limits: {
      pick: { minIntervalMs: 90, maxVoices: 3 }, // 経験値ダイヤはまとめて取ることが多く、音が約1秒あるので重なりすぎないように
    },
    files: {
      beam: "assets/sounds/beam.mp3",
      explosion: "assets/sounds/explosion-fighter.mp3",
      bigExplosion: "assets/sounds/explosion-mothership.mp3",
      start: "assets/sounds/round-start.mp3",
      slowStart: "assets/sounds/slow-start.mp3",
      slowEnd: "assets/sounds/slow-end.mp3",
      summary: "assets/sounds/summary.mp3",
      boss: "assets/sounds/target-appear.mp3",
      levelUp: "assets/sounds/menu-open.mp3",
      pick: "assets/sounds/xp-pick.mp3", // 経験値ダイヤを取った音(効果音ラボ「キャンセル7」。2026-11-02 オーナー指定)
      hit: "assets/sounds/shield-hit.mp3",
      mainGun: "assets/sounds/main-gun.mp3",
      saber: "assets/sounds/saber.mp3",
    },
    bgm: "assets/sounds/bgm-hyper-surge.mp3",
  },

  // 省電力(src/power-save.js)。操作が無いまま時間がたつと、描画を間引き → 止める。試合中・リプレイ再生中は対象外
  powerSave: {
    lowAfterSeconds: 20, // 操作が無いまま、この秒で描画を間引く
    lowFps: 20, // 間引いているときの描画回数(毎秒)
    sleepAfterSeconds: 60, // 操作が無いまま、この秒で描画を止めて「タップで再開」を出す
  },

  links: {
    senseofvoid: "https://senseofvoid.pages.dev/",
    senseofdopa: "https://senseofdopa.pages.dev/", // このゲームの本番のアドレス(画面写真の帯と共有の文)
  },
};
